export default "__VITE_ASSET__Ds29nLY5__"